import { createSlice } from '@reduxjs/toolkit';
import {
  configInterface,
  configInterfaceKeyNames,
  pagesInterface,
} from '../interfaces';
import { PriceView } from '../hooks/useGetGrossPrice';
import update from 'immutability-helper';
import { forEach } from 'lodash';
// import moment from 'moment';

const params = new URL(window.location.href).searchParams;
const rtlLanguages = ['he_IL','ar_SA'];
let initLang = 'he_IL';

const pagesWithSamePath = (
  path1: string | string[],
  path2: string | string[]
): boolean => {
  if (typeof path1 == 'string' && typeof path2 == 'string') {
    return path1 === path2;
  }
  if (
    path1?.length !== path2?.length ||
    !Array.isArray(path1) ||
    !Array.isArray(path2)
  ) {
    return false;
  }
  return path1.sort().join() === path2.sort().join();
};

const deleteModuleLogic = (
  state: any,
  instance: string,
  moduleName: string
) => {
  if (moduleName && instance === moduleName) {
    debugger;
    return;
  }
  const currModuleConfigs = { ...state.config.modulesConfigs };
  delete currModuleConfigs[instance]; // Remove the key
  state.config.modulesConfigs = currModuleConfigs;
  delete currModuleConfigs[instance]; // Remove the key
};

const initialState: stateInterface = {
  config: {} as configInterface,
  // whiteLabelConfig: {} as configInterface,
  translations: {},
  agentInfo: {},
  currentLang: initLang,
  direction: rtlLanguages.includes(initLang) ? 'rtl' : 'ltr',
  isLayoutModalOpen: null,
  // remove: isUpgradePlanModalOpen
  isUpgradePlanModalOpen: false,
  isOtpAuthCheckModalOpen: false,
  membershipUser: null,

};
interface MembershipUserType {
  data: {
    TZ: string;
    Phone: string;
    Org_Code: string;
    Org_Name: string;
    Shave_Eligibility: string;
    Error_Message: string;
  };
  user_name: string;
}

interface stateInterface {
  config: configInterface;
  // whiteLabelConfig: configInterface;
  translations: any;
  agentInfo: any;
  currentLang: any;
  direction: "ltr" | "rtl";
  isLayoutModalOpen: null | {
    type: 'update-card' | 'upgrade-plan' ;
    data?: any;
  };
  // remove: isUpgradePlanModalOpen
  isUpgradePlanModalOpen: boolean;
  isOtpAuthCheckModalOpen: boolean;
  membershipUser: MembershipUserType | null;
}

export const configSlice = createSlice({
  name: 'config',
  initialState,
  reducers: {
    setIsUpgradePlanModalOpen: (state, action) => {
      state.isLayoutModalOpen = action.payload;
      // remove: isUpgradePlanModalOpen
      state.isUpgradePlanModalOpen = action.payload;
    },
    setIsOtpAuthCheckModalOpen: (state, action) => {
      state.isOtpAuthCheckModalOpen = action.payload;
    },
    updateConfig: (state, action) => {
      state.config = action.payload;
    },
    updateLang: (state, action) => {
      state.currentLang = action.payload;
      state.direction = rtlLanguages.includes(action.payload) ? 'rtl' : 'ltr';
    },
    updateTranslations: (state, action) => {
      state.translations = action.payload;
    },
    updateAgentInfo: (state, action) => {
      state.agentInfo = action.payload;
    },
    updateAgentPriceView: (state, action) => {
      const priceView = action.payload.isGrossPrice
        ? PriceView.Gross
        : PriceView.Net;
      localStorage.setItem('price_view', JSON.stringify(priceView));

      state.agentInfo.agent.price_view = priceView;
    },
    // updateModuleTheme: (state: any, action) => {
    //   const { moduleName, theme } = action.payload;
    //   state.config.modulesConfigs[moduleName].theme = theme;
    // },
    // updateSiteTheme: (state, action) => {
    //   const { theme } = action.payload;
    //   state.config.theme = theme;
    // },
    // updateLayout: (state, action) => {
    //   const { layouts } = action.payload;
    //   state.config.layouts = layouts;
    // },

    updateLayoutModulesIndexes: (state, action) => {
      const { dragIndex, hoverIndex, layoutName, layoutSection } =
        action.payload;
      const prevCards = state.config.layouts[layoutName][layoutSection];
      const updatedLayout = update(prevCards, {
        $splice: [
          [dragIndex, 1],
          [hoverIndex, 0, prevCards[dragIndex]],
        ],
      });
      const layouts = {
        ...state.config.layouts,
        [layoutName]: {
          ...state.config.layouts[layoutName],
          [layoutSection]: updatedLayout,
        },
      };
      state.config.layouts = layouts;
    },
    setMembershipUser: (state, action) => {
      state.membershipUser = action.payload;
    },
      deleteLayoutModules: (state, action) => {
          const { moduleToDelete, layoutName, layoutSection } = action.payload;
          const layouts = {
              ...state.config.layouts,
              [layoutName]: {
                  ...state.config.layouts[layoutName],
                  [layoutSection]: state.config.layouts[layoutName][
                      layoutSection
                      ].filter((item: string) => item !== moduleToDelete),
              },
          };
          state.config.layouts = layouts;
      },

      updateModuleIndex: (state, action) => {
          const { dragIndex, hoverIndex, pageId } = action.payload;
          const currPages = [...state.config.pages];
          const updatedPages = currPages.map((page) => {
              if (page.id === pageId || page.name === pageId) {
                  const pageModulesInUpdatedOrder = update(page.modules, {
                      $splice: [
                          [dragIndex, 1],
                          [hoverIndex, 0, page.modules[dragIndex]],
                      ],
                  });
                  const returnVal = { ...page, modules: pageModulesInUpdatedOrder };

                  return returnVal;
              }
              return page;
          });

          state.config.pages = updatedPages;
      },
      deleteModuleFromPage: (state, action) => {
          const { instance, pageId, moduleName } = action.payload;
          const currPages = [...state.config.pages];
          let isInstanceInUse = false;
          const updatedPages = currPages.map((page) => {
              if (!isInstanceInUse && page?.modules?.includes(instance)) {
                  isInstanceInUse = true;
              }
              if (page.id === pageId || page.name === pageId) {
                  const returnVal = {
                      ...page,
                      modules: page.modules.filter((el) => el !== instance),
                  };

                  return returnVal;
              }
              return page;
          });

          state.config.pages = updatedPages;

          // DELETE MODULE FROM modulesConfigs if it is not used on any pages:
          if (!isInstanceInUse) {
              // // IF CONDITION IS MET USE deleteModuleFromConfigs logic
              // deleteModuleLogic(state, instance, moduleName);
          }
      },

      deleteModuleFromConfigs: (state, action) => {
          const { instance, moduleName } = action.payload;
          deleteModuleLogic(state, instance, moduleName);
          // const { instance, moduleName } = action.payload;
          // if (moduleName && instance === moduleName) {
          //   return;
          // }

          // const currModuleConfigs = { ...state.config.modulesConfigs };
          // delete currModuleConfigs[instance]; // Remove the key
          // state.config.modulesConfigs = currModuleConfigs;
      },
  },
});

export const {
  setIsOtpAuthCheckModalOpen,
  setIsUpgradePlanModalOpen,
  updateConfig,
  updateTranslations,
  updateAgentInfo,
  updateAgentPriceView,
  // updateModuleTheme,
  // updateSiteTheme,
  // updateLayout,
  updateLayoutModulesIndexes,
  deleteLayoutModules,
  updateLang,
  setMembershipUser,
  updateModuleIndex,
  deleteModuleFromPage,
  deleteModuleFromConfigs,
} = configSlice.actions;

export default configSlice.reducer;
